// El aviso de "llegó la hora de publicar" — MOCKEADO a propósito.
//
// Las notificaciones se están construyendo en otra rama. Este archivo existe
// para que el resto del calendario se escriba contra su forma final y no contra
// un `TODO` desparramado: cuando aquella rama aterrice se cambia el cuerpo de
// `avisarQueTocaPublicar` y NADA más se entera.
//
// Por eso tampoco simula de más —no hay timers ni colas— : lo único que tiene
// que ser verdad hoy es la FIRMA. Un mock que finge trabajar invita a creerle.

export interface AvisoDePost {
  postId: string;
  lanzamientoId: string;
  /** Lo que el usuario va a leer en la notificación. */
  titulo: string;
  cuando: Date;
}

export interface ResultadoDeAviso {
  /** `false` mientras las notificaciones no existan. */
  enviado: boolean;
  motivo: string;
}

/**
 * Todavía no avisa nada.
 *
 * Devuelve `enviado: false` en vez de `true`: si mintiera, la pantalla diría
 * "te avisamos" y el usuario se perdería el post confiando en eso. Que la
 * pantalla tenga que decir la verdad es justamente lo que queremos que pase
 * hasta que el aviso exista.
 */
export async function avisarQueTocaPublicar(_aviso: AvisoDePost): Promise<ResultadoDeAviso> {
  return { enviado: false, motivo: "Las notificaciones todavía no están conectadas" };
}

/** Si hoy el sistema puede avisar. La pantalla lo usa para no prometer de más. */
export function losAvisosFuncionan(): boolean {
  return false;
}

/**
 * Si tiene sentido preguntarle al usuario qué pasa cuando llega la hora.
 *
 * Hoy NO: ni el aviso ni el publicador automático existen, así que las dos
 * opciones hacen exactamente lo mismo —nada— y elegir entre ellas es decorado.
 * Mientras estuvo a la vista hubo que acompañarla de un cartelito explicando que
 * todavía no pasa nada, o sea una pregunta y su desmentida juntas; se esconden
 * las dos (ADR-2026-09-16-si-las-dos-opciones-hacen-lo-mismo-no-hay-que-preguntar).
 *
 * Lo que la sostiene NO se borra: `modo_publicacion` se sigue guardando con su
 * default y el interruptor y su modal siguen escritos. El día que el publicador
 * exista, esto devuelve `true` y vuelve todo.
 */
export function sePuedeElegirQuePasaALaHora(): boolean {
  return false;
}
